// extracted by mini-css-extract-plugin
module.exports = {"header":"NyBEt","logo":"XIDS6","group":"iwppY","group-info":"D0vhc","group-name":"Gr3-u","group-description":"q43SN","grid":"JURc3"};